module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/logout/logout.component.html
// module id = ./src/app/logout/logout.component.html
// module chunks = 1